import React, { useState } from 'react';
import { connect } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Modal
} from '@material-ui/core';

import CustomToolbar from 'components/CustomToolbar/CustomToolbar';
import ProductGroupDetails from 'components/Products/ProductGroupDetails';

import { deleteProductGroup } from 'redux/actions';

const ProductGroupsTable = ({isCategory, elements, ...props}) => {

  const [rowsSelected, setRowsSelected] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const columns = [
    { name: "name", label: isCategory ? "Category" : "Brand" }
  ];

  const onRowSelectionChange = (curr, all, rowsSelected) => {
    setRowsSelected(rowsSelected);
  };

  const deleteGroup = () => {
    
    const deletedGroup = elements[rowsSelected[0]].name;

    const groupInUse = props.products.some(product => {
      if(isCategory) return product.category === deletedGroup
      else return product.company === deletedGroup
    });

    if(groupInUse) setOpenDeleteModal(true);
    else props.deleteProductGroup(deletedGroup, isCategory);

    setRowsSelected([]);
  };

  const handleDeleteModalClose = () => {
    setOpenDeleteModal(false);
  };

  const customToolbarSelect = () => {
    return (
      <CustomToolbar
        switchy={2}
        element={isCategory ? "Category" : "Brand"}
        setDelete={deleteGroup}
      />
    )
  };

  const options = {
    filterType: 'checkbox',
    selectableRows: 'single',
    selectableRowsOnClick: true,
    rowsSelected,
    onRowSelectionChange,
    customToolbarSelect,
    download: false,
    print: false,
    filter: false,
    viewColumns: false
  };

  return (
    <React.Fragment>
      <Box display="flex" flexDirection="row">
        <Box width="50%" marginRight={1}>
          <MUIDataTable 
            title={isCategory ? "Product Categories" : "Product Brands"}
            data={elements}
            columns={columns}
            options={options}
          />
        </Box>
        <Box width="50%">
          <ProductGroupDetails
            isCategory={isCategory}
          />
        </Box>
      </Box>
      { openDeleteModal ?
        <Modal
          open={openDeleteModal}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '20%'
          }}
        >
          <Card>
            <CardHeader
              title="Cannot Delete."
            />
            <Divider />
            <CardContent>
                <p> The Category/Brand(s) is still in use. <br/>
                Change these values of elements and try again.
                {} </p>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleDeleteModalClose}
                >
                  Ok
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Modal>
      : null }
    </React.Fragment>
  )
};

export default connect (null, {deleteProductGroup}) (ProductGroupsTable);